import { defineStore } from 'pinia'
import Api from '../api/Api'

export const usePodLegalStore = defineStore('podLegal', {
  state: () => ({
    podlegal: null,
  }),
  getters: {},
  actions: {
    async refreshPodLegal(podId) {
      const response = await Api.podlegal.getPodLegal(podId);
      this.podlegal = response.data;
      return this.podlegal;
    },

    async savePodLegal(podId, payload) {
      const response = await Api.podlegal.savePodLegal(podId, payload);
      this.podlegal = response.data;
      return response.data;
    }
  },
});
